import get from 'lodash/get';
import { useQuery } from 'react-query';

import * as Api from '../api';
import * as Constants from '../constants';
import * as Mappers from '../mappers';

const useServiceSphere = () => {
  const initialData = { items: [] };

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, 'all'],
    async () => {
      const { data } = await Api.ServiceSphere();

      const items = (get(data, 'data') || []).map(item => Mappers.ServiceSphere(item));

      return { items };
    },
    { initialData, keepPreviousData: true }
  );

  return { ...data, ...args };
};

export default useServiceSphere;
